import { useDispatch } from "react-redux";
import { upsertPO } from "../../slices/purchasesOrdersSlice";
import { useEffect, useState } from "react";
import { PencilIcon } from '@heroicons/react/24/outline';
import { SaveCancelButtons } from "../SaveCancelButtons";
import { useRef } from "react";

export const POSidebarInformation = ({
    searchValue,
    currentStatuses,
    access,
    poPage,
    poItemsPerPage,
    currentPOId,
    currentPO,
    testId
}) => {

    const dispatch = useDispatch();
    const [currentInvoice, setCurrentInvoice] = useState(currentPO.invoice || "");
    const [currentPackagingCost, setCurrentPackagingCost] = useState(currentPO.packagingCost || "");
    const [editInvoice, setEditInvoice] = useState(false);
    const [editCost, setEditCost] = useState(false);

    const inputInvoiceRef = useRef(null);
    const inputCostRef = useRef(null);

    useEffect(() => {
        if (currentPOId !== currentPO.id) {
            setEditInvoice(false);
            setEditCost(false);
        }
    }, [currentPO.id])

    useEffect(() => {
        if (editInvoice && inputInvoiceRef?.current) {
            inputInvoiceRef?.current?.focus();
        }
    }, [editInvoice])

    useEffect(() => {
        if (editCost && inputCostRef?.current) {
            inputCostRef?.current?.focus();
        }
    }, [editCost])

    useEffect(() => {
        if (testId) return
        setCurrentInvoice(currentPO.invoice)
        setCurrentPackagingCost(currentPO.packagingCost)
    }, [currentPO])

    const handleSaveInvoice = async () => {
        if (access === "edit") {
            if (currentPO.invoice !== currentInvoice) {
                await dispatch(upsertPO({ 
                    po: {
                        ...currentPO,
                        invoice: currentInvoice || "",
                    },
                    search: searchValue, 
                    statuses: currentStatuses, 
                    page: poPage,
                    itemsPerPage: poItemsPerPage
                }));
            }
            setEditInvoice(false)
        }
    }
    const handleSavePackagingCost = async () => {
        if (access === "edit") {
            if (currentPO.packagingCost !== currentPackagingCost) {
                await dispatch(upsertPO({ 
                    po: {
                        ...currentPO,
                        packaging_cost: currentPackagingCost || "",
                    },
                    search: searchValue, 
                    statuses: currentStatuses, 
                    page: poPage,
                    itemsPerPage: poItemsPerPage
                }));
            }
            setEditCost(false)
        } 
    }
    const closeClickPackagingCost = () => {
        setEditCost(false)
        setCurrentPackagingCost(currentPO.packagingCost || "")
    }
    const closeClickInvoice = () => {
        setEditInvoice(false)
        setCurrentInvoice(currentPO.invoice || "")
    }
    return (
        <>
            <div className="mb-4 text-sm text-gray-500">
                <p>{currentPO.vendor}</p>
                <p>{currentPO.poDate}</p>
                <p className="mt-1 h-5 flex gap-2">
                    Invoice: 
                    {!editInvoice && (
                        <div className="flex gap-2 font-medium">
                            {`${currentPO.invoice ? currentPO.invoice : 'N/A'}`}
                            {access === "edit" && (
                                <PencilIcon 
                                    className="h-4 w-4 cursor-pointer" 
                                    aria-hidden="true" 
                                    onClick={() => {
                                        setEditInvoice(true)
                                    }} 
                                />
                            )}
                        </div>
                    )}
                    {editInvoice && (
                        <>
                            <input 
                                type="text" 
                                ref={inputInvoiceRef}
                                name="invoice" 
                                className="bg-gray-50 font-medium border border-gray-300 text-gray-900 text-sm rounded-sm block w-48 dark:bg-gray-700 dark:border-gray-600 dark:text-white" 
                                value={currentInvoice}
                                onKeyDown={async (event) => {
                                    if (
                                        (event.key === "Enter") || 
                                        (event.ctrlKey && event.key === "Enter")
                                    ) {
                                        event.preventDefault();
                                        await handleSaveInvoice();
                                    }
                                    if (event.key === "Escape") {
                                        closeClickInvoice();
                                    }
                                }}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setCurrentInvoice(value)
                                }}
                            />
                            <SaveCancelButtons 
                                testId={testId}
                                saveOnClick={async () => {
                                    await handleSaveInvoice();
                                }}
                                cancelOnClick={() => {
                                    closeClickInvoice();
                                }}
                            />
                        </>
                    )}
                </p>
                <p className="mt-1 h-5 flex gap-2">
                    Total Packaging cost: 
                    {!editCost && (
                        <div className="flex gap-2 font-medium">
                            {`${currentPO.packagingCost ? `$${currentPO.packagingCost}` : '$0'}`}
                            {access === "edit" && (
                                <PencilIcon 
                                    className="h-4 w-4 cursor-pointer" 
                                    aria-hidden="true" 
                                    onClick={() => {
                                        setEditCost(true)
                                    }} 
                                />
                            )}
                        </div>
                    )}
                    {editCost && (
                        <>
                            <input 
                                type="text" 
                                ref={inputCostRef}
                                name="packagingCost" 
                                className="bg-gray-50 font-medium border border-gray-300 text-gray-900 text-sm rounded-sm block w-48 dark:bg-gray-700 dark:border-gray-600 dark:text-white" 
                                value={currentPackagingCost}
                                onKeyDown={async (event) => {
                                    if (
                                        (event.key === "Enter") || 
                                        (event.ctrlKey && event.key === "Enter")
                                    ) {
                                        event.preventDefault();
                                        await handleSavePackagingCost();
                                    }
                                    if (event.key === "Escape") {
                                        closeClickPackagingCost();
                                    }
                                }}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setCurrentPackagingCost(value)
                                }}
                            />
                            <SaveCancelButtons 
                                testId={testId}
                                saveOnClick={async () => {
                                    await handleSavePackagingCost();
                                }}
                                cancelOnClick={() => {
                                    closeClickPackagingCost();
                                }}
                            />
                        </>
                    )}
                </p>
            </div>
        </>
    )
}